module.exports = __webpack_public_path__ + "media/levelup3.dd49e8d8.webm";